<template>
  <div class="menu-wrapper" ref="menu">
    <div @click="triggerClick" :class="classButtonContainer" :ref="refButtonContainer">
      <slot name="menu-button" v-if="$slots['menu-button']" :toggleMenu="e => toggleMenu(e)"></slot>
      <button
        v-else
        class="menu-wrapper-button"
        ref="button"
        :aria-expanded="isOpen.toString()"
        aria-haspopup="true"
        :aria-controls="id"
        @click="toggleMenu"
      >
        <slot name="menu-button-text"></slot>
      </button>
    </div>
    <teleport to="body">
      <ul
        class="menu-wrapper-menu"
        :class="[classRoot, dbOptionHeight]"
        v-if="isOpen"
        ref="list"
        role="menu"
        :id="id"
        @close_menu="closeHandler()"
        :style="{
          left: left,
          right: right,
          top: top,
          bottom: bottom,
          maxHeight: maxHeight + 'px',
          overflow: 'auto',
        }"
      >
        <slot name="menu-content" :closeHandler="closeHandler"></slot>
      </ul>
    </teleport>
  </div>
</template>

<script>
import {nextTick} from 'vue';
import componentUtil from '@/commons/componentUtil';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';

export default {
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    hideInContent: {
      default: true,
      type: Boolean,
    },
    maxHeight: {
      default: null,
      type: [Number, String],
    },
    classRoot: {
      default: '',
      type: [String, Array],
    },
    position: {
      default: null,
      type: Object,
    },
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    /** Căn trái */
    isLeft: {
      default: true,
      type: Boolean,
    },
    refButtonContainer: {
      default: 'buttonContainer',
      type: String,
    },
    classButtonContainer: {
      default: 'menu-button-container',
      type: String,
    },
    classDestroyHide: {
      default: 'destroy-hide-wrapper',
      type: String,
    },
  },

  data: function () {
    return {
      isOpen: false,
      id: null,
      left: 'unset',
      right: 'unset',
      top: 0,
      bottom: 'unset',
    };
  },
  mounted() {
    this.id = Math.random().toString(36).substring(2, 15);
  },
  unmounted() {
    document.removeEventListener('keydown', this.documentKeydown);
    document.removeEventListener('click', this.documentClick);
  },
  beforeUnmount() {
    let el = this.$refs.list;
    el && el.remove();
  },
  watch: {
    isOpen(newVal, oldVal) {
      let me = this;
      if (newVal) {
        /** Thực hiện gán sự kiện click outside */
        if (this.isGridEditor) {
          // Nếu thuộc grid thì thực hiện action Click. fake-click: là class nằm ngoài của formpopup
          // việc trigger vào đây sẽ giúp cho control trên grid ko bị dispose
          document.querySelector('.fake-click').click();
        } else {
          if (document.querySelector('.fake-click-popup')) {
            // Không phải grid thì trigger vào đây. fake-click-popup: là class con của formID.
            // Mỗi popup có grid chứa combo có quickAddMulti thì cần có formID là root của form popup đó
            // trigger vào đây thì grideditor sẽ chạy onClickAway và dispose control đi
            document.querySelector('.fake-click-popup').click();
          } else if (this.refButtonContainer === 'buttonContainer') {
            // MenuWrapper này nằm ngoài danh sách, ko có formID thì sẽ chạy vào đây
            // document.querySelector('body').click();
            me.$nextTick(() => {
              EventBusGlobal.$emit(GlobalEventName.openWrapper, {
                container: [me.$refs.list],
                element: me.$el,
                button: me.$refs.buttonContainer,
              });
            });
          }
        }
        setTimeout(() => {
          document.addEventListener('keydown', me.documentKeydown);
          document.addEventListener('click', me.documentClick);
          EventBusGlobal.$on(GlobalEventName.openWrapper, me.openWrapperOther);
        }, 0);

        this.top = '0px';
        this.left = '0px';

        this.$nextTick(() => {
          let position = componentUtil.getPosition(
            this.$refs[this.refButtonContainer],
            this.$refs['list'],
            this.position,
          );

          this.top = position.top + 'px';
          // this.left = position.left + 'px';
          this.left = this.isLeft ? position.left + 'px' : 'unset';
          this.right = this.isLeft ? 'unset' : position.right + 'px';
        });
      } else {
        this.$emit('closeMenuWrapper');
        document.removeEventListener('keydown', me.documentKeydown);
        document.removeEventListener('click', me.documentClick);
        EventBusGlobal.$off(GlobalEventName.openWrapper, me.openWrapperOther);
      }
    },
  },
  methods: {
    documentKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeHandler();
      }
    },
    isDispose(target) {
      let el = this.$refs.list;
      /** Các container sẽ ko dispose cell */
      const classes = ['.calendar-container.datepicker'];
      const dispose =
        classes.findIndex(className => {
          return target.closest && (target.closest(className) || target.className.contains(className));
        }) === -1;

      if (dispose && el !== target && !el.contains(target)) {
        return true;
      }
    },
    documentClick(e) {
      let el = this.$refs.list;
      let target = e.target;
      let isSubgroup = !!target.closest('.menu-group-item');

      if (!isSubgroup) {
        if (this.hideInContent) {
          let destroy = target.closest(`.${this.classDestroyHide}`);
          if (!destroy) {
            this.closeHandler();
          }
          return;
        }

        if (this.isDispose(target)) {
          let destroy = target.closest(`.${this.classDestroyHide}`);
          if (!destroy) {
            this.closeHandler();
            this.closeHandler();
          }
        }
      }
    },
    openWrapperOther({container, element, button}) {
      let cont = container || [];
      let btn = this.$refs.buttonContainer;

      if (element == this.$el) {
        return;
      }

      this.$nextTick(() => {
        if (cont.some(x => this.$refs.list?.contains(button))) {
          container.push(this.$refs.list);
        } else {
          this.closeHandler();
        }
      });
    },
    toggleMenu(e) {
      e.stopPropagation();
      // Kiểm tra xem có đang hiển thị MISAIDAccount không
      // bug 470314
      var menu = MISAIDAccount?.menu?.el;
      if(menu && window.getComputedStyle(menu).display !== 'none'){
        MISAIDAccount.menu.hide();
      }

      if (!this.disabled) {
        this.$emit('click', !this.isOpen);
        this.isOpen = !this.isOpen;

        //Add class đánh dấu active
        if (this.isOpen) {
          this.$el.classList.add('active');
        } else {
          this.$el.classList.remove('active');
        }
        this.$emit('toggleMenu', e, this.isOpen);
      }
    },
    closeHandler() {
      this.isOpen = false;

      //remove
      this.$el.classList.remove('active');
    },
    /**
     * Hàm thực thi click khi chỉ có 1 button trong buttonContainer
     */
    triggerClick() {
      let buttons = this.$refs.buttonContainer.querySelectorAll('button');
      if (buttons.length == 1) {
        buttons[0].click();
      }
    },
  },
  computed: {
    dbOptionHeight() {
      return 'heightoptionvalueMenuWrapper' + parseInt(this.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    },
  },
};
</script>

<style lang="scss">
.menu-wrapper-button {
  background-color: transparent;
  border: 1px solid #555;
  cursor: pointer;
  font-size: inherit;
  display: inline-block;
  border-radius: 3px;
  font-weight: $font-weight-bold;
  line-height: 20px;
  padding: 0 5px;
  text-align: center;
  white-space: nowrap;
  margin: 0 0 0 4px;
}

.menu-wrapper-button:focus {
  outline: 0;
  color: #236ca4;
  border-color: #236ca4;
  box-shadow: 0 0 3px 2px #236ca4;
}

.menu-wrapper-menu {
  list-style: none;
  margin: 0;
  padding: 4px;
  animation: slide-down 0.2s ease;
  position: absolute;
  z-index: 9999;
  background-color: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  min-width: 136px;
  /** Style scrollbar trên FireFox**/
  scrollbar-color: #b8bcc3 transparent;
  scrollbar-width: thin;
  /** Style scrollbar trên FireFox**/
}

.menu-wrapper-item {
  outline: none;
  color: inherit;
  text-decoration: none;
  line-height: $combo-height;
  height: $combo-height;
  cursor: pointer;
  padding: 0 16px;
  display: block;
  transition: all 0.7s ease;
  white-space: nowrap;
}

.menu-wrapper-item.initial-focus,
.menu-wrapper-item:hover {
  outline: 0;
  background-color: $menu-wapper-hv;
  border-radius: 2px;
  color: $primary;
  transition: all 0.2s ease;
  .menu-item-ic {
    &.ic-filter- {
      &contain:before {
        background-position: -432px -240px;
      }
      &equal:before {
        background-position: -359px -288px;
      }
      &not-equal:before {
        background-position: -335px -288px;
      }
      &not-contain:before {
        background-position: -311px -336px;
      }
      &greater-than:before {
        background-position: -263px -288px;
      }
      &greater-than-or-eq:before {
        background-position: -312px -288px;
      }
      &less-than:before {
        background-position: -240px -288px;
      }
      &less-than-or-eq:before {
        background-position: -289px -288px;
      }
      &start-with:before {
        background-position: -431px -288px;
      }
      &ends-with:before {
        background-position: -457px -288px;
      }
      &null:before {
        background-position: -384px -288px;
      }
      &not-null:before {
        background-position: -408px -288px;
      }
      &remove:before {
        background-position: -192px -288px;
      }
    }
  }
}

@keyframes slide-down {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.heightoptionvalueMenuWrapper1 {
  font-size: $font-size-custom-small !important;
}
.heightoptionvalueMenuWrapper2 {
  font-size: $font-size-custom-big !important;
}
</style>
